import { DashboardLayout } from '@/components/layout/DashboardLayout';
import RiskHealthDashboard from '@/components/compliance/RiskHealthDashboard';

export default function RiskHealth() {
  return (
    <DashboardLayout>
      <RiskHealthDashboard />
    </DashboardLayout>
  );
}
